/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Themelight1Inputs */

const zh_user_themelight1 = /** @type {(inputs: User_Themelight1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浅色`)
};

const en_user_themelight1 = /** @type {(inputs: User_Themelight1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light`)
};

const es_user_themelight1 = /** @type {(inputs: User_Themelight1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

/**
* | output |
* | --- |
* | "Light" |
*
* @param {User_Themelight1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const user_themelight1 = /** @type {((inputs?: User_Themelight1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Themelight1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_user_themelight1(inputs)
	if (locale === "en") return en_user_themelight1(inputs)
	return es_user_themelight1(inputs)
});
export { user_themelight1 as "user_themeLight" }